import {TpaLearningCenterConsentDefinition} from './tpaLearningCenterConsent'

export {TpaLearningCenterConsentDefinition}
